import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import VueI18n from 'vue-i18n';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/el-element.css'
// tailwind CSS is imported directly in home_pc_b.vue via pre-compiled hexgo-tailwind.css
import i18n from './common/lang';
// import enLocale from 'element-ui/lib/locale/lang/en';
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

// echarts 按需加载 - 首次调用时才下载
let _echartsCache = null;
Vue.prototype.$getEcharts = function() {
  if (_echartsCache) return Promise.resolve(_echartsCache);
  return import(/* webpackChunkName: "echarts" */ './utils/echarts.js').then(m => {
    _echartsCache = m.default;
    return _echartsCache;
  });
};
Vue.config.productionTip = false

import { getMarketFlagSrc } from '@/common/currencyFlagMap';

Vue.mixin({
  methods: {
    /**
     * 获取品种 logo：优先本地国旗 SVG → 降级到数据库 logo
     * 用法: <img :src="getMarketLogo(item)" />
     */
    getMarketLogo(item) {
      if (!item) return '';
      const localFlag = getMarketFlagSrc(item.code);
      if (localFlag) return localFlag;
      return item.logo || '';
    },
    onLogoError(e, code) {
      const el = e.target;
      if (el.dataset.fallback === '2') return;
      // 第一次失败：尝试本地国旗
      if (!el.dataset.fallback) {
        el.dataset.fallback = '1';
        const localFlag = getMarketFlagSrc(code);
        if (localFlag) { el.src = localFlag; return; }
      }
      // 最终降级：字母占位符
      el.dataset.fallback = '2';
      const letter = (code || '?').charAt(0).toUpperCase();
      el.src = 'data:image/svg+xml,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"><rect width="80" height="80" rx="8" fill="%23409EFF"/><text x="40" y="52" font-size="36" fill="white" text-anchor="middle" font-family="Arial">' + letter + '</text></svg>'
      );
    }
  }
})
/** 国际化 **/
// Vue.use(VueI18n);
// Vue.use(ElementUI, {
//   i18n: (key, value) => i18n.t(key, value)
// });
// const i18n = new VueI18n({
//   locale: 'en',
//   messages: {
//     'zh': Object.assign(require('@/common/lang/zh'), zhLocale),
//     'en': Object.assign(require('@/common/lang/en'), enLocale),
//   }
// });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')